import { InspectorServiceRegionAddRequest, InspectorServiceRegionResponse, InspectorServiceRegionUpdateRequest } from "interfaces/Mueller.Business.Models";
import { Ref } from "react";
import { HTTP_GET, HTTP_POST, HTTP_DELETE, WebApiRequest, HTTP_PUT } from "tools/webservice";

export const addInspectorServiceRegion = (inspectorNumber: number, addRequest: InspectorServiceRegionAddRequest, successCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/inspector-service-regions/inspector/${inspectorNumber}`,
  payload: addRequest,
  successCallback,
  mountedRef,
});

export const updateInspectorServiceRegions = (updateRequest: InspectorServiceRegionUpdateRequest, successCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/inspector-service-regions/inspector/${updateRequest.inspectorNumber}`,
  payload: updateRequest,
  successCallback,
  mountedRef,
});

export const getInspectorServiceRegions = (inspectorNumber: number, successCallback:(regions: InspectorServiceRegionResponse[]) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/inspector-service-regions/${inspectorNumber}/service-regions`,
  successCallback,
  mountedRef,
});

export const deleteInspectorServiceRegion = (regionId: number, successCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/inspector-service-regions/region/${regionId}`,
  successCallback,
  mountedRef,
});
